/**
 * Internationalization (i18n) for Filmssavn Admin
 * Supports Faroese (fo) and English (en)
 */

const translations = {
  fo: {
    // Navigation
    nav_dashboard: 'Yvirlit',
    nav_upload: 'Legg upp',
    nav_manage: 'Umsit',
    nav_settings: 'Stillingar',
    nav_view_site: 'Sí heimasíðu',
    nav_logout: 'Rita út',

    // Dashboard
    dashboard_title: 'Yvirlit',
    dashboard_total_videos: 'Filmar í alt',
    dashboard_ready: 'Klárir',
    dashboard_encoding: 'Verða gjørdir',
    dashboard_recent_uploads: 'Nýggjastu upplegg',
    dashboard_no_videos: 'Eingir filmar enn. Legg upp tín fyrsta film!',
    dashboard_stats_title: 'Hagtøl',
    dashboard_stats_subtitle: 'Virksemi higartil í ár',
    dashboard_paid_stats_title: 'Goldnar leigur',
    dashboard_free_stats_title: 'Ókeypis filmar',
    stats_paid_rentals: 'Goldnar leigur',
    stats_unique_film_payments: 'Serstøk brúkara-film pør',
    stats_gross_revenue: 'Bruttoinntøka',
    stats_paying_users: 'Gjaldandi brúkarar',
    stats_distinct_paid_films: 'Goldnir filmar',
    stats_repeat_rentals: 'Endurtiknar leigur',
    stats_average_transaction: 'Miðal leiga',
    stats_refunds: 'Afturgoldið',
    stats_free_films: 'Ókeypis filmar',
    stats_free_views: 'Ókeypis vísingar',
    stats_unique_viewers: 'Serstakir hyggjarar',
    stats_watched_free_films: 'Sæddir ókeypis filmar',
    stats_completions: 'Liðugt sædd',
    stats_watch_time: 'Hyggitíð',
    stats_monthly_breakdown: 'Mánaðir',
    stats_film_breakdown: 'Filmar',
    stats_free_monthly_breakdown: 'Ókeypis mánaðir',
    stats_free_film_breakdown: 'Ókeypis filmar',
    stats_month: 'Mánaður',
    stats_paid_films: 'Goldnir filmar',
    stats_users: 'Brúkarar',
    stats_views: 'Vísingar',
    stats_viewers: 'Hyggjarar',
    stats_gross: 'Brutto',
    stats_film: 'Filmur',
    stats_last_paid: 'Seinast goldið',
    stats_last_viewed: 'Seinast sæddur',
    stats_no_paid_rentals: 'Ongar goldnar leigur í tíðarskeiðnum',
    stats_no_free_activity: 'Eingin ókeypis hygging í tíðarskeiðnum',
    stats_load_error: 'Kann ikki lesa leiguhagtøl',

    // Upload
    upload_title: 'Legg upp film',
    upload_drag_drop: 'Drag og slepp videofílu her ella trýst fyri at velja',
    upload_selected: 'Valdar',
    upload_remove: 'Strika',
    upload_select_file: 'Vel Fílu',
    upload_button: 'Legg upp film',
    upload_uploading: 'Leggur upp...',
    upload_success: 'Filmurin er klárur!',
    upload_error: 'Brek við upplegging',

    // Rights holder terms
    rights_warranty_title: "Váttan um rættindi (Producer's Warranty)",
    rights_terms_title: 'Treytir fyri rættindahavarar',
    rights_terms_checkbox: 'Eg vátti, at eg havi rættindini til at leggja filmin út, og at eg havi lisið og góðtikið',
    rights_terms_link: 'Treytir fyri rættindahavarar',
    rights_terms_required:
      'Tú mást vátta rættindini og góðtaka Treytir fyri rættindahavarar, áðrenn tú leggur filmin upp.',
    rights_terms_version_label: 'Útgáva',
    rights_terms_back_upload: 'Aftur til upplegging',
    rights_terms_draft_notice: 'Enska útgávan er ein fyribils umseting til gjøgnumgongd.',
    rights_terms_audit_title: "Váttan um rættindi (Producer's Warranty)",
    rights_terms_audit_accepted: 'Góðtikið',
    rights_terms_audit_missing: 'Ikki skrásett',
    rights_terms_audit_version: 'Útgáva',
    rights_terms_audit_date: 'Dagfesting',
    rights_terms_audit_user: 'Brúkari',
    rights_terms_audit_language: 'Mál',
    rights_terms_audit_ip: 'IP-adressa',
    rights_terms_audit_user_agent: 'User agent',

    // Manage
    manage_title: 'Umsit filmar',
    manage_subtitle: 'Sí og rætta allar filmar',
    manage_upload_new: 'Legg upp nýggjan',
    manage_search: 'Leita...',
    manage_filter_all: 'Allir filmar',
    manage_filter_documentary: 'Heimildarfilmar',
    manage_filter_short: 'Stuttfilmur',
    manage_filter_feature: 'Spælifilmur',
    manage_filter_processing: 'Verða gjørdir',
    manage_no_videos: 'Eingir filmar funnir',
    manage_edit: 'Rætta',
    manage_status: 'Støða',
    manage_delete: 'Strika',
    manage_play: 'Spæl',
    manage_faroese_original: 'Original',
    manage_uploaded_by: 'Upplagt av',

    // Settings
    settings_title: 'Stillingar',
    settings_language: 'Mál',
    settings_language_fo: 'Føroyskt',
    settings_language_en: 'Enskt',
    settings_save: 'Goym',
    settings_saved: 'Stillingar goymdar',
    settings_access_title: 'Brúkarar og atgongd',
    settings_access_subtitle: 'Stýr hvør hevur umsitingaratgongd í forritinum.',
    settings_access_user: 'Brúkari',
    settings_access_role: 'Leiklutur',
    settings_access_updated: 'Dagført',
    settings_access_no_users: 'Eingir brúkarar funnir',
    settings_access_load_error: 'Kann ikki lesa brúkarar',
    settings_access_saved: 'Atgongd dagførd',
    settings_access_save_error: 'Kann ikki dagføra atgongd',
    settings_role_admin: 'Admin',
    settings_role_filmmaker: 'Filmsfólk',
    settings_role_user: 'Brúkari',

    // Video Status
    status_created: 'Stovnaður',
    status_uploaded: 'Lagdur upp',
    status_encoding: 'Verður gjørdur',
    status_ready: 'Klárur',
    status_failed: 'Miseydnaðist',
    status_unknown: 'Ókend',

    // Video Form - Sections
    form_section_basic: 'Grundupplýsingar',
    form_section_crew: 'Liðið',
    form_section_technical: 'Tøkniligar upplýsingar',
    form_edit_video: 'Rætta film',

    // Video Form - Category
    form_category: 'Flokkur',
    category_short: 'Stuttfilmur',
    category_feature: 'Spælifilmur',
    category_documentary_short: 'Stuttur heimildarfilmur',
    category_documentary_long: 'Longri heimildarfilmur',

    // Video Form - Basic Info
    form_original_title: 'Føroyskt heiti',
    form_international_title: 'Enskt heiti',
    form_synopsis: 'Stuttur søgusamandráttur',

    // Video Form - Crew
    form_director: 'Leikstjóri',
    form_screenwriter: 'Handritahøvundur',
    form_producer: 'Framleiðari',
    form_production_company: 'Framleiðslufelag',
    form_coproduction_company: 'Samframleiðslufelag',
    form_dop: 'Filmsfotografur',
    form_editor: 'Klippari',
    form_composer: 'Tónaskald',
    form_main_cast: 'Høvuðsleikarar',
    form_key_crew: 'Lyklapersónar á filmsliðnum',

    // Video Form - Images
    form_poster_url: 'Plakat (2:3)',
    form_still_url: 'Stillmynd (16:9)',

    // Video Form - Technical
    form_runtime_hours: 'Longd (Tímar)',
    form_runtime_minutes: 'Longd (Minuttir)',
    form_language: 'Mál',
    form_subtitles: 'Undirtekstir',
    form_production_year: 'Framleiðsluár',
    form_imdb_link: 'Leinkja til IMDB',

    // Form placeholders
    placeholder_firstname: 'Fornavn',
    placeholder_middlename: 'Millumnavn',
    placeholder_lastname: 'Eftirnavn',
    placeholder_name: 'Navn',
    placeholder_synopsis: 'Skriva stuttan søgusamandrátt...',
    placeholder_link: 'https://imdb.com/title/...',
    placeholder_poster_url: 'https://example.com/poster.jpg',
    placeholder_still_url: 'https://example.com/still.jpg',

    // Actions
    action_save: 'Goym',
    action_cancel: 'Angra',
    action_close: 'Lat aftur',
    action_confirm_delete: 'Ert tú vísur í, at tú vilt strika filmin?',

    // Messages
    msg_loading: 'Lesur...',
    msg_error: 'Brek',
    msg_success: 'Eydnaðist',
  },

  en: {
    // Navigation
    nav_dashboard: 'Dashboard',
    nav_upload: 'Upload',
    nav_manage: 'Manage',
    nav_settings: 'Settings',
    nav_view_site: 'View Site',
    nav_logout: 'Logout',

    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_total_videos: 'Total Videos',
    dashboard_ready: 'Ready',
    dashboard_encoding: 'Encoding',
    dashboard_recent_uploads: 'Recent Uploads',
    dashboard_no_videos: 'No videos yet. Upload your first film!',
    dashboard_stats_title: 'Stats',
    dashboard_stats_subtitle: 'Year-to-date activity',
    dashboard_paid_stats_title: 'Paid Rentals',
    dashboard_free_stats_title: 'Free Films',
    stats_paid_rentals: 'Paid Rentals',
    stats_unique_film_payments: 'Unique User-Film Pairs',
    stats_gross_revenue: 'Gross Revenue',
    stats_paying_users: 'Paying Users',
    stats_distinct_paid_films: 'Paid Films',
    stats_repeat_rentals: 'Repeat Rentals',
    stats_average_transaction: 'Average Rental',
    stats_refunds: 'Refunds',
    stats_free_films: 'Free Films',
    stats_free_views: 'Free Views',
    stats_unique_viewers: 'Unique Viewers',
    stats_watched_free_films: 'Watched Free Films',
    stats_completions: 'Completions',
    stats_watch_time: 'Watch Time',
    stats_monthly_breakdown: 'Monthly Breakdown',
    stats_film_breakdown: 'Film Breakdown',
    stats_free_monthly_breakdown: 'Free Monthly Breakdown',
    stats_free_film_breakdown: 'Free Film Breakdown',
    stats_month: 'Month',
    stats_paid_films: 'Paid Films',
    stats_users: 'Users',
    stats_views: 'Views',
    stats_viewers: 'Viewers',
    stats_gross: 'Gross',
    stats_film: 'Film',
    stats_last_paid: 'Last Paid',
    stats_last_viewed: 'Last Viewed',
    stats_no_paid_rentals: 'No paid rentals in this period',
    stats_no_free_activity: 'No free viewing activity in this period',
    stats_load_error: 'Unable to load rental stats',

    // Upload
    upload_title: 'Upload Film',
    upload_drag_drop: 'Drag and drop video file here or click to select',
    upload_selected: 'Selected',
    upload_remove: 'Remove',
    upload_select_file: 'Select File',
    upload_button: 'Upload Film',
    upload_uploading: 'Uploading...',
    upload_success: 'Film uploaded successfully!',
    upload_error: 'Upload failed',

    // Rights holder terms
    rights_warranty_title: "Rights declaration (Producer's Warranty)",
    rights_terms_title: 'Terms for Rights Holders',
    rights_terms_checkbox: 'I confirm that I hold the rights to upload this film and that I have read and accepted the',
    rights_terms_link: 'Terms for Rights Holders',
    rights_terms_required:
      'You must confirm the rights and accept the Terms for Rights Holders before uploading the film.',
    rights_terms_version_label: 'Version',
    rights_terms_back_upload: 'Back to upload',
    rights_terms_draft_notice: 'The English version is a draft translation for review.',
    rights_terms_audit_title: "Rights declaration (Producer's Warranty)",
    rights_terms_audit_accepted: 'Accepted',
    rights_terms_audit_missing: 'Not recorded',
    rights_terms_audit_version: 'Version',
    rights_terms_audit_date: 'Date',
    rights_terms_audit_user: 'User',
    rights_terms_audit_language: 'Language',
    rights_terms_audit_ip: 'IP address',
    rights_terms_audit_user_agent: 'User agent',

    // Manage
    manage_title: 'Manage Films',
    manage_subtitle: 'View and edit all films',
    manage_upload_new: 'Upload New',
    manage_search: 'Search...',
    manage_filter_all: 'All Films',
    manage_filter_documentary: 'Documentaries',
    manage_filter_short: 'Short Feature',
    manage_filter_feature: 'Feature',
    manage_filter_processing: 'Processing',
    manage_no_videos: 'No films found',
    manage_edit: 'Edit',
    manage_status: 'Status',
    manage_delete: 'Delete',
    manage_play: 'Play',
    manage_faroese_original: 'Original',
    manage_uploaded_by: 'Uploaded by',

    // Settings
    settings_title: 'Settings',
    settings_language: 'Language',
    settings_language_fo: 'Faroese',
    settings_language_en: 'English',
    settings_save: 'Save',
    settings_saved: 'Settings saved',
    settings_access_title: 'Users and Access',
    settings_access_subtitle: 'Control who has application access from inside Stroyma.',
    settings_access_user: 'User',
    settings_access_role: 'Role',
    settings_access_updated: 'Updated',
    settings_access_no_users: 'No users found',
    settings_access_load_error: 'Unable to load users',
    settings_access_saved: 'Access updated',
    settings_access_save_error: 'Unable to update access',
    settings_role_admin: 'Admin',
    settings_role_filmmaker: 'Filmmaker',
    settings_role_user: 'User',

    // Video Status
    status_created: 'Created',
    status_uploaded: 'Uploaded',
    status_encoding: 'Encoding',
    status_ready: 'Ready',
    status_failed: 'Failed',
    status_unknown: 'Unknown',

    // Video Form - Sections
    form_section_basic: 'Basic Information',
    form_section_crew: 'Crew',
    form_section_technical: 'Technical Details',
    form_edit_video: 'Edit Video',

    // Video Form - Category
    form_category: 'Category',
    category_short: 'Short Feature',
    category_feature: 'Feature',
    category_documentary_short: 'Short Documentary',
    category_documentary_long: 'Long Documentary',

    // Video Form - Basic Info
    form_original_title: 'Original Title',
    form_international_title: 'English Title',
    form_synopsis: 'Brief Synopsis',

    // Video Form - Crew
    form_director: 'Director',
    form_screenwriter: 'Screenwriter',
    form_producer: 'Producer',
    form_production_company: 'Production Company',
    form_coproduction_company: 'Co-Production Company',
    form_dop: 'Director of Photography',
    form_editor: 'Editor',
    form_composer: 'Music Composer',
    form_main_cast: 'Main Cast',
    form_key_crew: 'Key Crew',

    // Video Form - Images
    form_poster_url: 'Upload Poster (2:3)',
    form_still_url: 'Upload Still (16:9)',

    // Video Form - Technical
    form_runtime_hours: 'Runtime (Hours)',
    form_runtime_minutes: 'Runtime (Minutes)',
    form_language: 'Language',
    form_subtitles: 'Subtitles',
    form_production_year: 'Production Year',
    form_imdb_link: 'Link – IMDB',

    // Form placeholders
    placeholder_firstname: 'First Name',
    placeholder_middlename: 'Middle Name',
    placeholder_lastname: 'Last Name',
    placeholder_name: 'Name',
    placeholder_synopsis: 'Write a brief synopsis...',
    placeholder_link: 'https://imdb.com/title/...',
    placeholder_poster_url: 'https://example.com/poster.jpg',
    placeholder_still_url: 'https://example.com/still.jpg',

    // Actions
    action_save: 'Save',
    action_cancel: 'Cancel',
    action_close: 'Close',
    action_confirm_delete: 'Are you sure you want to delete this film?',

    // Messages
    msg_loading: 'Loading...',
    msg_error: 'Error',
    msg_success: 'Success',
  },
};

// Current language (defaults to Faroese)
let currentLanguage = localStorage.getItem('filmssavn_language') || 'fo';

/**
 * Get translation for a key
 */
export function t(key) {
  return translations[currentLanguage][key] || key;
}

/**
 * Set current language
 */
export function setLanguage(lang) {
  if (translations[lang]) {
    currentLanguage = lang;
    localStorage.setItem('filmssavn_language', lang);
    // Trigger a custom event for components to re-render
    window.dispatchEvent(new CustomEvent('languagechange', { detail: { language: lang } }));
  }
}

/**
 * Get current language
 */
export function getLanguage() {
  return currentLanguage;
}

/**
 * Initialize i18n system
 */
export function initI18n() {
  const savedLang = localStorage.getItem('filmssavn_language');
  if (savedLang && translations[savedLang]) {
    currentLanguage = savedLang;
  }
}

/**
 * Get category display name (bilingual)
 */
export function getCategoryDisplay(category) {
  if (!category) return '';

  const categoryMap = {
    documentary: { fo: 'Heimildarfilmur', en: 'Documentary' },
    documentary_short: {
      fo: 'Stuttur heimildarfilmur',
      en: 'Short Documentary',
    },
    documentary_long: { fo: 'Longri heimildarfilmur', en: 'Long Documentary' },
    short: { fo: 'Stuttfilmur', en: 'Short Feature' },
    feature: { fo: 'Spælifilmur', en: 'Feature' },
  };

  const cat = categoryMap[category];
  if (!cat) return category;

  // Return bilingual format: "Føroyskt / English"
  return `${cat.fo} / ${cat.en}`;
}
